export default __webpack_public_path__ + "static/media/om.9f40eca5.svg";